import {
  GET_ALL_USERS,
  GET_ALL_DESKTOP_USERS,
  GET_ALL_WEB_USERS,
  GET_USER,
  GET_ME,
  LOADING_USER,
  LOADING_ME,
  ERROR_PROFILE,
  ERROR_USER,
  ADD_USER,
  UPDATE_PROFILE_DETAILS,
  UPDATE_PROFILE_PASSWORD,
  UPDATE_PASSWORD,
  UPDATE_USER,
  DELETE_USER
} from "store/actions/userAction";

export default (store = {}, action) => {
  switch (action.type) {
    case LOADING_USER:
      return {
        ...store,
        isLoadingUser: action.payload
      };
    case LOADING_ME:
      return {
        ...store,
        isLoadingMe: action.payload
      };
    case ERROR_PROFILE:
      return {
        ...store,
        errorProfile: action.payload
      };
    case ERROR_USER:
      return {
        ...store,
        errorUser: action.payload
      };
    case GET_ALL_USERS:
      return {
        ...store,
        getAllUsers: action.payload
      };
    case GET_ALL_DESKTOP_USERS:
      return {
        ...store,
        getAllDesktopUsers: action.payload
      };
    case GET_ALL_WEB_USERS:
      return {
        ...store,
        getAllWebUsers: action.payload
      };
    case GET_USER:
      return {
        ...store,
        getUser: action.payload
      };
    case GET_ME:
      return {
        ...store,
        getMe: action.payload
      };
    case ADD_USER:
      return {
        ...store,
        addUser: action.payload
      };
    case UPDATE_PROFILE_DETAILS:
      return {
        ...store,
        updateProfileDetails: action.payload
      };
    case UPDATE_PROFILE_PASSWORD:
      return {
        ...store,
        updateProfilePassword: action.payload
      };
    case UPDATE_USER:
      return {
        ...store,
        updateUser: action.payload
      };
    case UPDATE_PASSWORD:
      return {
        ...store,
        updateUserPassword: action.payload
      };
    case DELETE_USER:
      return {
        ...store,
        deleteUserStatus: action.payload
      };
    default:
      return store;
  }
};
